<template>
  <div class="d-flex align-items-center">
    <b-form-group
      label="Etsi paikkaa"
      style="margin-right: 10px; width: 100%;"
    >
      <v-select
        :v-model="selectedPlaces"
        :options="options"
        :dir="$store.state.hwUiLayout.isRTL ? 'rtl' : 'ltr'"
        :reduce="val => val.value"
        :debounce="5000"
        multiple
        @search="(val) => fetchPlaces(val)"
        @input="(val) => $emit('update:selectedPlaces', val)"
      />
    </b-form-group>
    <b-form-group
      label="Säde"
      style="width: 150px;">
      <v-select
        v-model="radius"
        :options="radiusOptions"
        :dir="$store.state.hwUiLayout.isRTL ? 'rtl' : 'ltr'"
        :reduce="val => val.value"
        :clearable="false"
        @input="(val) => updateRadius(val)"
      />
    </b-form-group>
   
  </div>
</template>
  
  <script>
  import axios from 'axios'
  import {functions, auth} from '@/shared/services/firebase'
  import { BFormGroup } from 'bootstrap-vue'
  import vSelect from 'vue-select'
  import _ from 'lodash'
  
  export default {
    components: {
      vSelect,
      BFormGroup,
    },
    data() {
      return {
        searchText: '',
        places: [],
        options: [],
        selectedPlaces: null,
        radius: 50,
        radiusOptions: [
          { label: '20 km', value: 20 },
          { label: '50 km', value: 50 },
          { label: '80 km', value: 80 },
          { label: '100 km', value: 100 },
          { label: '150 km', value: 150 },
          { label: '200 km', value: 200 },
        ],
      }
    },
    methods: {
      updateRadius(val) {
        this.radius = val
        this.options = this.places.map(place => ({
          label: (place.name ? ` ${place.name} (${val} km)` : ''),
          value: {center: place.location, radius: val},
        }))
      },
      fetchWithDebounce: _.debounce(async (val, vm) =>{
        const idToken = await auth.currentUser.getIdToken()
        const apiUrl = `${functions.url}/fetchPlacesByText?searchText=${val}`
        const response = await axios
          .post(apiUrl, {
            token: idToken,
          })
        // eslint-disable-next-line no-param-reassign
        vm.places = response.data
        // eslint-disable-next-line no-param-reassign
        vm.options = response.data.map(place => ({
          label: (place.name ? ` ${place.name} (${vm.radius} km)` : ''),
          value: {center: place.location, radius: vm.radius},
        }))
        return response.data
      }, 250),
      async fetchPlaces(searchText) {
        if(!searchText || searchText.length < 2) {
          this.options = []
          return
        }
        await this.fetchWithDebounce(searchText, this)
      },
    },
  }
  </script>
  <style lang="scss" scoped>
  @import '@hw-ui/scss/vue/libs/vue-select.scss';
  .item {
        min-height: 100px;
        margin: 8px;
        border: 1px solid #ccc;
        border-radius: 5px;
        padding: 10px;
        flex:auto;
    }
    ::v-deep .weeks-dropdown {
      background-color: pink;
      .dropdown-menu {
        max-height: 300px;
        overflow-y: auto;
      }
    }
  </style>
  